import { Fragment } from "react";

import HeaderComponent from "./components/HeaderComponent";
import FormComponent from "./components/FormComponent";
import TableComponent from "./components/TableComponent";

export default function App() {
  return (
    <Fragment>
      <HeaderComponent />
      <FormComponent />
      <TableComponent />
    </Fragment>
  );
}
